import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";
import { MarcasVehiculoFindOneInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculoFindOne.interface";

export async function FinOneMarcaVehiculoAction (
    MarcaId: string
): Promise<ApiResponse<MarcasVehiculoFindOneInterface>> {
   const {data} = await apiClient.get(`gvMarcaVehiculos/${MarcaId}`);
    return {
        status: 200,
        data,
        message: "Marcas de vehiculo obtenida correctamente",
    };
}